// 直接引入 uni.webview 文件，它会自动挂载到 window.uni
import "./uni.webview.1.5.6.js";
// 主要是用于处理接收UniApp的消息
import handleUniMessage from "./uni-mes";

// 封装H5向UniApp发送消息
class UniappH5Bridge {
  constructor() {
    this.historyStack = []; // 记录路由栈
    this.init();
  };

  // 初始化
  init() {
    this.handleMessage();
    // this.setupRouterListener();
  };

  // 处理消息 H5发送 or UniApp发送
  handleMessage() {
    document.addEventListener("UniAppJSBridgeReady", () => {
      // 向UniApp发送消息
      window.postMessageToUniApp = (message) => {
        window.uni.postMessage({ data: message });
      };
      // 接收来自UniApp的消息
      window.receiveUniAppMessage = (message) => {
        // if (message.type != 'H5PageBack') {
        //   handleUniMessage(message, this.historyStack);
        // };
        handleUniMessage(message);
      };
    });
  };

  // 设置路由监听
  setupRouterListener() {
    this.overrideHistoryMethods();
    this.setupVueRouterListener();
    this.setupHashChangeListener();
    // 初始状态
    this.onRouterChange();
  };
  // 重写history方法
  overrideHistoryMethods() {
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;
    history.pushState = (...args) => {
      originalPushState.apply(history, args);
      this.onRouterChange();
    };
    history.replaceState = (...args) => {
      originalReplaceState.apply(history, args);
      this.onRouterChange();
    };
    window.addEventListener('popstate', () => {
      setTimeout(() => this.onRouterChange(), 100);
    });
  };
  // 设置Vue Router监听（如果使用Vue Router）
  setupVueRouterListener() {
    if (window.__VUE__ && window.__VUE__.app && window.__VUE__.app.config.globalProperties.$router) {
      const router = window.__VUE__.app.config.globalProperties.$router;
      router.afterEach(() => {
        setTimeout(() => this.onRouterChange(), 100);
      });
    }
  };
  // 监听hash变化
  setupHashChangeListener() {
    window.addEventListener('hashchange', () => {
      this.onRouterChange();
    });
  };

  // 路由变化 记录在路由栈中
  onRouterChange() {
    const state = {
      canGoBack: history.length > 1,
      historyCount: history.length,
      currentUrl: window.location.href,
      timestamp: Date.now()
    };
    this.historyStack = state;
    this.notifyRouterChange(state);
  };
  // 通知UniApp路由变化
  notifyRouterChange(state) {
    window.uni.postMessage({
      data: {
        type: 'routerChange',
        ...state
      }
    });
  };
};

new UniappH5Bridge();
